import { render, staticRenderFns } from "./TabListaHonraria.vue?vue&type=template&id=5ab8e15a&scoped=true"
import script from "./TabListaHonraria.vue?vue&type=script&lang=ts"
export * from "./TabListaHonraria.vue?vue&type=script&lang=ts"
import style0 from "./TabListaHonraria.vue?vue&type=style&index=0&id=5ab8e15a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab8e15a",
  null
  
)

export default component.exports